var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-flex-wrap gl-items-center gl-gap-3"},[(_vm.showAgeIndicator)?_c('blame-legend'):_vm._e(),_vm._v(" "),_c('blame-preferences',{attrs:{"has-revs-file":_vm.hasRevsFile},on:{"toggle-age-indicator":_vm.onToggleAgeIndicator}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }